import {
	ADD_ACHIEVEMENTS,
	ADD_SOCIAL_MEDIA,
	DELETE_PROFILE_IMAGE,
	GET_USER_INFO,
	REMOVE_ACHIEVEMENT,
	REMOVE_PHOTO,
	REMOVE_LINK,
	REMOVE_SOCIAL_MEDIA,
	UPDATE_PROFILE,
	UPLOAD_IMAGE,
	UPLOAD_IMAGE_LINKS,
	UPLOAD_PROFILE_IMAGE,
} from '../constants/ActionTypes';

export const getUserInfo = (
	data: {
		userName: string;
	},
	success?: (user: any) => void,
	failed?: () => void
) => ({
	type: GET_USER_INFO,
	payload: { ...data },
	success,
	failed,
});

export const updateProfile = (
	data: [],
	success?: () => void,
	failed?: () => void
) => ({
	type: UPDATE_PROFILE,
	payload: { ...data },
	success,
	failed,
});

export const uploadProfileImage = (
	data: { data: any; hash: any },
	success?: () => void,
	failed?: () => void
) => ({
	type: UPLOAD_PROFILE_IMAGE,
	payload: { ...data },
	success,
	failed,
});

export const addSocialMedia = (
	data: { provider; link },
	success?: () => void,
	failed?: () => void
) => ({
	type: ADD_SOCIAL_MEDIA,
	payload: { socialLinks: { ...data } },
	success,
	failed,
});

export const removeSocialMedia = (
	data,
	success?: () => void,
	failed?: () => void
) => ({
	type: REMOVE_SOCIAL_MEDIA,
	payload: data,
	success,
	failed,
});

export const addAchievements = (
	data: { title; subTitle; summary },
	success?: () => void,
	failed?: () => void
) => ({
	type: ADD_ACHIEVEMENTS,
	payload: { achievement: { ...data } },
	success,
	failed,
});

export const removeAchievement = (
	data,
	success?: () => void,
	failed?: () => void
) => ({
	type: REMOVE_ACHIEVEMENT,
	payload: data,
	success,
	failed,
});

export const uploadImgLinks = (
	data: { icon; url; title },
	success?: () => void,
	failed?: () => void
) => ({
	type: UPLOAD_IMAGE_LINKS,
	payload: { links: { ...data } },
	success,
	failed,
});

export const removeLink = (
	data,
	success?: () => void,
	failed?: () => void
) => ({
	type: REMOVE_LINK,
	payload: data,
	success,
	failed,
});

export const removePhoto = (
	data: { id; hash },
	success?: () => void,
	failed?: () => void
) => ({
	type: REMOVE_PHOTO,
	payload: { ...data },
	success,
	failed,
});

export const uploadImage = (
	data: { data },
	success?: () => void,
	failed?: () => void
) => ({
	type: UPLOAD_IMAGE,
	payload: { ...data },
	success,
	failed,
});

export const deleteProfileImage = (
	data: string,
	success?: () => void,
	failed?: () => void
) => ({
	type: DELETE_PROFILE_IMAGE,
	payload: data,
	success,
	failed,
});
